import { render, staticRenderFns } from "./BackofficeDataSolicitadaOperadora.vue?vue&type=template&id=0219474c"
import script from "./BackofficeDataSolicitadaOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeDataSolicitadaOperadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports